import configDataFn from '@/baseData/personalOrder/manageList'
import { limitInteger18 } from '@/utils/validate'
import { FuzzySearch, getPersonalOrders } from '@/api/purchaseAndSaleAPI'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

export default function () {
  const jumpDetail = (query) => {
    query.orderType = 'personal'
    this.$router.push({
      path: '/vehicle/vehicleManage/detail',
      query,
    })
  }

  // 客户名称模糊搜索loading
  let loading = false
  // 车牌号&客户名称模糊搜索
  const remoteMethod = async (query, str) => {
    if (str === 'customerId') {
      if (query.length >= 1) {
        // 开启远程搜索
        loading = true
        try {
          const { code, data = [] } = await searchByCustomerNameSensitive({
            customerState: 1,
            customerType: 1,
            customerName: query,
          })
          loading = false
          if (code === 1) {
            // 关闭远程搜索
            this.$refs.baseListManagement.setItemData({
              elConfigKey: 'list',
              key: 'customerId',
              data,
            })
          }
        } finally {
          // 关闭远程搜索
          loading = false
        }
      } else {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'list',
          key: 'customerId',
          data: [],
        })
      }
    } else {
      // 车牌号
      // eslint-disable-next-line no-lonely-if
      if (query.length >= 4) {
        // 开启远程搜索
        loading = true
        const { code, data } = await FuzzySearch({
          state: 1,
          plateNo: query,
        })
        loading = false
        if (code === 1) {
          // 关闭远程搜索
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'carId',
            data,
          })
        }
      } else {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'list',
          key: 'carId',
          data: [],
        })
      }
    }
  }

  const formData = [
    {
      el: 'select',
      itemConfig: {
        label: '客户名称',
        prop: 'customerId',
      },
      elConfig: {
        filterable: true,
        remote: true,
        'reserve-keyword': true,
        placeholder: '请输入',
        'remote-method': (e) => {
          remoteMethod(e, 'customerId')
        },
        events: {
          change: () => {
            const customerIdItem = this.configData.formData.list.find((item) => item.itemConfig.prop === 'customerId')
            if (customerIdItem) {
              this.customerConditionList = customerIdItem.elConfig.options.list
            }
          },
        },
        jsxRender: (option) => {
          return <CustomerNameOptionItem data={option} />
        },
        options: {
          label: 'customerName',
          value: 'id',
          list: [],
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '订单ID',
        prop: 'id',
      },
      elConfig: {
        placeholder: '请输入订单ID',
        maxlength: '18',
        events: {
          input: (e) => {
            limitInteger18(e, (ee) => {
              this.$set(this.configData.formData.formProps.model, 'id', ee)
            })
          },
        },
      },
    },
  ]

  const operate = {
    name: 'operate',
    columnProps: {
      label: '操作',
      fixed: 'right',
    },
    type: 'operate',
    maxShowLength: operateMaxShowLength,
    getOperateList: ({ row }) => {
      const arr = [
        {
          label: '详情',
          action: () => jumpDetail({ id: row.id, tabType: 'personalOrder' }),
        },
      ]
      return arr
    },
  }
  const { configData } = configDataFn.call(this, {
    bizType: 10,
    tabNo: 0,
    dealWithData: this.dealWithData,
  })
  configData.tableData.apiFn = getPersonalOrders
  configData.formData.list = [...formData, ...configData.formData.list]
  configData.tableData.columns.push(operate)
  configData.isShowDepartment = false
  return { configData }
}
